import React, { useEffect, useState } from 'react'
import { cn } from '@utils/safeTs'
import styles from './EditorArticoloPrincipaleEditModal.module.sass'
import { EditorStatusType } from '@utils/types'
import { Alert, Button, FormField, FormSelect, Modal } from '@components/atoms'
import useTrans from '@hooks/useTrans'


interface Props {
  status?: EditorStatusType
  coloriArticoli?: any[]
  open?: boolean
  onClose?: () => void
  onApply?: (v: number) => void
  className?: string
}

const EditorArticoloPrincipaleEditModal = (props: Props) => {

  const { 
    status,
    coloriArticoli = [],
    open = false,
    onClose,
    onApply,
    className = '',
  } = props

  const t = useTrans()
  const [localValue, setLocalValue] = useState(status?.articoloPrincipale?.colore?.id?.toString())

  // TODO - ci sono possibili errori qui?
  // const [errors, setErrors] = useState([])

  return (
    <Modal 
      id={'editorarticoloprincipaleeditmodal'}
      open={open}
      onClose={onClose}
      title={t("Modifica colore principale")}
      buttons={(
        <>
          <Button variant="secondary" size="large" label={t("Annulla")} onClick={onClose} />
          <Button 
            variant='primary' 
            size="large" 
            label={t("Applica modifica")} 
            onClick={onApply ? () => onApply(parseInt(localValue)) : undefined} 
            disabled={status.tecnica?.id?.toString() === localValue} // || errors?.filter(e => e.blocking)?.length > 0} 
          />
        </>
      )}
      className={cn(styles.root, className)}
      mainClassName={styles.main}
      headerClassName={styles.head}
      bodyClassName={styles.body}
    >
      <Alert 
        full
        variant='warning' 
        styleVariant='background' 
        placeholder={t("La modifica del colore principale riadatta automaticamente loghi e testi alla nuova area di stampa")}  
      />
      <div className={styles.selection}>
        <FormField 
          id={'editorarticoloprincipaleeditmodal_articolo'}
          label={t("Colore principale")}
        >
          <FormSelect 
            id={'editorarticoloprincipaleeditmodal_articolo'}
            value={localValue}
            onChange={(e) => setLocalValue(e.target.value)}
            options={coloriArticoli.map(a => ({
              label: a.colore?.nome, 
              value: a.colore?.id?.toString(),
            }))}
          />
        </FormField>
      </div>
      {/* {!!errors?.length && (
        <div className={styles.errors}>
          {errors.map(error => (
            <Alert 
              full
              variant={error.level} 
              styleVariant='background' 
              placeholder={error.message}  
            />
          ))}
        </div>
      )} */}
    </Modal>
  )
}

export default EditorArticoloPrincipaleEditModal
